import { render, staticRenderFns } from "./FactStandard.vue?vue&type=template&id=405ad0f5&scoped=true&"
import script from "./FactStandard.vue?vue&type=script&lang=js&"
export * from "./FactStandard.vue?vue&type=script&lang=js&"
import style0 from "./FactStandard.vue?vue&type=style&index=0&id=405ad0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ad0f5",
  null
  
)

export default component.exports